(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-compare"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 6 · 对比视频播放
   ============================================================ */
if (!customElements.get('cf-compare')) {
  customElements.define('cf-compare', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      const go = this.querySelector('[data-go]');
      const pp = this.querySelector('[data-pp]');
      if (!go || !pp) return;
      this._ready = true;
      /* 用户手动按过暂停，就别再让滚动把它叫起来 */
      this.manual = false;

      go.addEventListener('click', () => { this.manual = false; this.play(); });
      pp.addEventListener('click', () => {
        if (this.classList.contains('is-paused')) { this.manual = false; this.play(); }
        else { this.manual = true; this.pause(); }
      });

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* 进视口自动放、出视口暂停。没视频的时候这段等于空转，不影响占位图 */
      if (!reduce && this.dataset.autoplay === '1' && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((es) => {
          es.forEach((e) => {
            if (!this.live().length) return;
            if (e.isIntersecting) { if (!this.manual) this.play(); }
            else this.live().forEach((v) => v.pause());
          });
        }, { threshold: 0.45 });
        this.io.observe(this);
      }
    }

    /* 只挑当前可见的那条（竖版 cut 在窄屏才显示），双画模式会拿到两条 */
    live() {
      return Array.prototype.slice.call(this.querySelectorAll('video'))
        .filter((v) => v.offsetParent !== null);
    }

    play() {
      const vs = this.live();
      if (!vs.length) return;
      this.classList.add('is-started');
      this.classList.remove('is-paused');
      /* 双画必须对齐时间轴，否则两边跑着就错开了 */
      for (let i = 1; i < vs.length; i++) vs[i].currentTime = vs[0].currentTime;
      vs.forEach((v) => {
        v.muted = true;
        v.playsInline = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
    }

    pause() {
      this.classList.add('is-paused');
      this.live().forEach((v) => v.pause());
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      if (this.io) this.io.disconnect();
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-faq"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 10 · FAQ 手风琴
   高度动画交给 CSS 的 0fr→1fr，这里只管 class 和 aria
   ============================================================ */
if (!customElements.get('cf-faq')) {
  customElements.define('cf-faq', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.qs = Array.prototype.slice.call(this.querySelectorAll('.cf-faq__q'));
      if (!this.qs.length) return;
      this._ready = true;
      /* 一次只留一个展开：FAQ 全开会把页尾拉得很长 */
      this.single = this.dataset.single === '1';

      this.qs.forEach((q) => {
        q.addEventListener('click', () => this.toggle(q));
      });

      /* 编辑器里点侧边栏的问答，直接展开对应那条 */
      this._onSelect = (e) => {
        const q = e.target.querySelector('.cf-faq__q');
        if (q && q.getAttribute('aria-expanded') !== 'true') this.toggle(q);
      };
      this.addEventListener('shopify:block:select', this._onSelect);
    }

    set(q, on) {
      q.parentNode.classList.toggle('is-on', on);
      q.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    toggle(q) {
      const on = q.parentNode.classList.contains('is-on');
      if (this.single) this.qs.forEach((o) => this.set(o, false));
      this.set(q, !on);
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-hero"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   众筹 HERO —— 三个自定义元素
   主逻辑用 custom element：
   主题编辑器里重新渲染 section 时 connectedCallback 会自动再跑一遍，
   一页放多个 hero 也各自独立，不用 querySelectorAll 全局扫
   ============================================================ */

/* ---------- 倒计时 ---------- */
if (!customElements.get('cf-countdown')) {
  customElements.define('cf-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = this.parse(this.dataset.deadline);
      if (!this.end) { this.hidden = true; return; }
      this.cells = {
        d: this.querySelector('[data-cf-c="d"]'),
        h: this.querySelector('[data-cf-c="h"]'),
        m: this.querySelector('[data-cf-c="m"]'),
        s: this.querySelector('[data-cf-c="s"]')
      };
      this.tick();
    }

    disconnectedCallback() { clearTimeout(this.timer); }

    /* 后台可能填 "2026-03-24T16:00:00Z"，也可能手打 "2026-03-24 16:00"。
       后者少了 T，Safari 直接 NaN，所以先补一下再解析 */
    parse(v) {
      if (!v) return 0;
      var t = Date.parse(v);
      if (isNaN(t)) t = Date.parse(String(v).trim().replace(' ', 'T'));
      return isNaN(t) ? 0 : t;
    }

    pad(n) { return n < 10 ? '0' + n : '' + n; }

    tick() {
      var left = Math.max(0, this.end - Date.now());
      var s = Math.floor(left / 1000);
      if (this.cells.d) this.cells.d.textContent = Math.floor(s / 86400);
      if (this.cells.h) this.cells.h.textContent = this.pad(Math.floor(s % 86400 / 3600));
      if (this.cells.m) this.cells.m.textContent = this.pad(Math.floor(s % 3600 / 60));
      if (this.cells.s) this.cells.s.textContent = this.pad(s % 60);
      if (left <= 0) {
        this.setAttribute('data-expired', '');
        /* 到点了：有替代文案就整块换掉，没有就停在 0 */
        if (this.dataset.done) this.textContent = this.dataset.done;
        return;
      }
      this.timer = setTimeout(this.tick.bind(this), 1000);
    }
  });
}

/* ---------- 产品舞台视频 ---------- */
if (!customElements.get('cf-stage')) {
  customElements.define('cf-stage', class extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('video');
      if (!v) return;
      /* Shopify 的 video_tag 不一定带 playsinline，iOS 上会强制全屏播 */
      v.playsInline = true;
      v.setAttribute('playsinline', '');

      var btn = this.querySelector('.cf-hero__playbtn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        this.classList.add('is-playing');
        v.play();
      }.bind(this));
    }
  });
}

/* ---------- 吸底 CTA ---------- */
if (!customElements.get('cf-sticky')) {
  customElements.define('cf-sticky', class extends HTMLElement {
    connectedCallback() {
      var anchor = document.querySelector(this.dataset.watch || '');
      if (!anchor || !('IntersectionObserver' in window)) return;

      /* 已经提交成功就不再骚扰 */
      if (anchor.querySelector('.cf-hero__msg--ok')) { this.remove(); return; }

      var self = this;
      var hideSelector = this.dataset.hideAt || 'footer,.site-footer,.shopify-section-group-footer-group,[id*="shopify-section-footer"],[id*="__footer"]';
      function isInView(el) {
        var rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      }

      this.anchorOut = false;
      this.hideTargetVisible = false;
      this.sync = function () {
        self.classList.toggle('is-show', self.anchorOut && !self.hideTargetVisible);
      };
      this.bindHideTarget = function () {
        var hideTarget = document.querySelector(hideSelector);
        self.hideTargetVisible = hideTarget ? isInView(hideTarget) : false;
        self.sync();

        if (!hideTarget || self.hideIo) return;
        self.hideIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.hideTargetVisible = e.isIntersecting;
            self.sync();
          });
        }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });
        self.hideIo.observe(hideTarget);
      };

      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* 只在主表单被「向上」滚出视口后才浮出；
             页面还没滚到那儿（表单在下方）时不该冒出来 */
          self.anchorOut = !e.isIntersecting && e.boundingClientRect.top < 0;
          self.sync();
        });
      }, { threshold: 0 });
      this.io.observe(anchor);

      this.bindHideTarget();
      if (!this.hideIo && document.readyState === 'loading') {
        this.onReady = function () { self.bindHideTarget(); };
        document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      }

      /* 吸底表单提交成功后整条收掉 */
      this.addEventListener('submit', function () { self.classList.remove('is-show'); });
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.hideIo) this.hideIo.disconnect();
      if (this.onReady) document.removeEventListener('DOMContentLoaded', this.onReady);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-install"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 3 · 机位切换
   ============================================================ */
if (!customElements.get('cf-install')) {
  customElements.define('cf-install', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.shots = Array.prototype.slice.call(this.querySelectorAll('.cf-install__shot'));
      this.dts = Array.prototype.slice.call(this.querySelectorAll('.cf-install__dt'));
      this.picks = Array.prototype.slice.call(this.querySelectorAll('.cf-install__pick'));
      this.pin = this.querySelector('[data-pin-el]');
      this.replay = this.querySelector('[data-replay]');
      if (!this.shots.length) return;
      this.cur = 0;
      this._ready = true;

      this.shots.forEach((s) => {
        const v = s.querySelector('video');
        if (v) { v.playsInline = true; v.muted = true; }
      });

      this.picks.forEach((p, i) => {
        p.addEventListener('click', () => { if (i !== this.cur) this.go(i); });
      });

      const picksWrap = this.querySelector('.cf-install__picks');
      if (picksWrap) {
        picksWrap.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const n = this.cur + (e.key === 'ArrowRight' ? 1 : -1);
          this.go((n + this.picks.length) % this.picks.length);
          if (this.picks[this.cur]) this.picks[this.cur].focus();
        });
      }

      if (this.replay) {
        this.replay.addEventListener('click', () => {
          const s = this.shots[this.cur];
          const v = s.querySelector('video');
          if (v) { v.currentTime = 0; v.play().catch(() => {}); }
          else {
            /* 没视频时重播 = 重新走一次进场动画 */
            s.classList.remove('is-on');
            requestAnimationFrame(() => requestAnimationFrame(() => s.classList.add('is-on')));
          }
        });
      }

      /* 后台点选某个机位 block 时跟着切 */
      this._onSelect = (e) => {
        const t = e.target.closest ? e.target.closest('.cf-install__dt') : null;
        if (!t || !this.contains(t)) return;
        const i = this.dts.indexOf(t);
        if (i > -1) this.go(i);
      };
      this.addEventListener('shopify:block:select', this._onSelect);

      this.go(0, true);
    }

    go(i, init) {
      this.cur = Math.max(0, Math.min(this.shots.length - 1, i));

      this.shots.forEach((s, n) => {
        const on = n === this.cur;
        s.classList.toggle('is-on', on);
        const v = s.querySelector('video');
        if (v) {
          if (on) { v.currentTime = 0; v.play().catch(() => {}); }
          else v.pause();
        }
      });
      this.dts.forEach((d, n) => d.classList.toggle('is-on', n === this.cur));
      this.picks.forEach((p, n) => {
        const on = n === this.cur;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
        p.tabIndex = on ? 0 : -1;
      });

      if (!this.pin) return;
      const s = this.shots[this.cur];
      if (!s.dataset.pin) { this.pin.hidden = true; return; }
      /* 机位标记：等媒体淡入到一半再出现，否则会跟着旧画面一起闪 */
      this.pin.hidden = true;
      clearTimeout(this._pt);
      const show = () => {
        this.pin.style.left = s.dataset.x;
        this.pin.style.top = s.dataset.y;
        this.pin.querySelector('i').textContent = this.cur + 1;
        this.pin.querySelector('span').textContent = s.dataset.pin;
        this.pin.hidden = false;
      };
      if (init) show(); else this._pt = setTimeout(show, 300);
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      clearTimeout(this._pt);
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-mirror-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-mirror-video')) {
  customElements.define('cf-mirror-video', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.section = this.closest('.cf-mirror-video');
      this.video = this.querySelector('video');
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.raf = 0;
      this.active = false;
      this._ready = true;

      if (this.video) {
        this.video.muted = true;
        this.video.loop = true;
        this.video.playsInline = true;
      }

      if (this.reduce) {
        this.paint(1);
        return;
      }

      this._onScroll = () => this.requestPaint();
      this._onResize = () => this.requestPaint();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.active = entry.isIntersecting;
            this.classList.toggle('is-active', this.active);
            if (this.video) {
              if (this.active) this.video.play().catch(() => {});
              else this.video.pause();
            }
            this.requestPaint();
          });
        }, { threshold: 0.08 });
        this._io.observe(this);
      } else {
        this.active = true;
        if (this.video) this.video.play().catch(() => {});
      }

      this.requestPaint();
    }

    requestPaint() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.update();
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const travel = Math.max(1, rect.height - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -rect.top / travel));
      this.paint(progress);
    }

    paint(progress) {
      if (!this.section) return;
      const style = window.getComputedStyle(this.section);
      const endScale = parseFloat(style.getPropertyValue('--cf-end-scale')) || 0.78;
      const scale = 1 - ((1 - endScale) * progress);

      this.section.style.setProperty('--cf-p', progress.toFixed(4));
      this.section.style.setProperty('--cf-scale', scale.toFixed(4));
      this.section.style.setProperty('--cf-inset-y', (progress * 31).toFixed(3) + '%');
      this.section.style.setProperty('--cf-inset-x', (progress * 3).toFixed(3) + '%');
      this.section.style.setProperty('--cf-corner', (16 + progress * 42).toFixed(2) + 'px');
      this.section.style.setProperty('--cf-shadow-y', (22 + progress * 18).toFixed(2) + 'px');
      this.section.style.setProperty('--cf-shadow-blur', (54 + progress * 42).toFixed(2) + 'px');
      this.section.style.setProperty('--cf-shade-o', (progress * 0.82).toFixed(4));
      this.section.style.setProperty('--cf-chrome-o', progress.toFixed(4));
      this.section.style.setProperty('--cf-hud-o', (progress * 0.76).toFixed(4));
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this._io) this._io.disconnect();
      if (this.video) this.video.pause();
      if (this.raf) cancelAnimationFrame(this.raf);
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-resolution"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 5 · sensor 呼吸点 / 参数弹窗
   ============================================================ */
if (!customElements.get('cf-resolution')) {
  customElements.define('cf-resolution', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.spots = Array.prototype.slice.call(this.querySelectorAll('.cf-res__spot'));
      if (!this.spots.length) return;
      this._ready = true;

      this.spots.forEach((sp) => {
        const dot = sp.querySelector('.cf-res__dot');
        const close = sp.querySelector('.cf-res__x');
        const pop = sp.querySelector('.cf-res__pop');
        if (dot) {
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            sp.classList.contains('is-on') ? this.close(sp) : this.open(sp);
          });
        }
        if (close) {
          close.addEventListener('click', (e) => {
            e.stopPropagation();
            this.close(sp);
            if (dot) dot.focus();
          });
        }
        /* 弹窗内点击不要冒泡到 document，否则刚开就被关掉 */
        if (pop) pop.addEventListener('click', (e) => e.stopPropagation());
      });

      this._onDocClick = () => this.closeAll();
      this._onKey = (e) => { if (e.key === 'Escape') this.closeAll(); };
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKey);

      /* 后台点选某个 sensor block 时直接把它的弹窗打开 */
      this._onSelect = (e) => {
        const sp = e.target.closest ? e.target.closest('.cf-res__spot') : null;
        if (sp && this.contains(sp)) this.open(sp);
      };
      this.addEventListener('shopify:block:select', this._onSelect);
    }

    open(sp) {
      this.spots.forEach((o) => { if (o !== sp) this.close(o); });
      sp.classList.add('is-on');
      /* 点开过就别再呼吸了，把注意力留给还没点的那个 */
      sp.classList.add('is-seen');
      const d = sp.querySelector('.cf-res__dot');
      if (d) d.setAttribute('aria-expanded', 'true');
    }

    close(sp) {
      sp.classList.remove('is-on');
      const d = sp.querySelector('.cf-res__dot');
      if (d) d.setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.spots.forEach((sp) => this.close(sp));
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-scenes"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 2 · 场景轮播
   写成 custom element 而不是 DOMContentLoaded：
   后台编辑器每次改设置都会重渲染整个 section，
   一次性的 DOMContentLoaded 在那之后不会再跑，轮播就死了
   ============================================================ */
if (!customElements.get('cf-scenes')) {
  customElements.define('cf-scenes', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      /* 主题打包出来的脚本可能在 body 解析完之前就执行，
         那时自定义元素的子节点还没进 DOM，直接 query 会全是 null */
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.car = this.querySelector('.cf-scenes__car');
      this.track = this.querySelector('[data-track]');
      this.bar = this.querySelector('[data-bar]');
      this.barFill = this.querySelector('[data-bar-fill]');
      if (!this.car || !this.track) return;

      this.slides = Array.prototype.slice.call(this.track.children);
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.cf-scenes__tab'));
      this.descs = Array.prototype.slice.call(this.querySelectorAll('.cf-scenes__desc'));
      this.prev = this.querySelector('.cf-scenes__nav.is-prev');
      this.next = this.querySelector('.cf-scenes__nav.is-next');
      this.tabsWrap = this.querySelector('.cf-scenes__tabs');
      this.cur = 0;
      this._cleanups = [];
      this._barRaf = 0;
      this._autoTimer = 0;
      this._barStartedAt = 0;
      this._barRemaining = 0;
      this._layoutRaf = 0;
      this._layoutAfterMove = false;
      this._switching = false;
      this._ready = true;

      /* 自动轮播：JS timer 是唯一切换驱动，进度条只显示当前 timer 的视觉进度。
         这样媒体、tab、进度条都从 this.cur 同步更新，不会被动画事件推乱。 */
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === '1' && this.slides.length > 1 && !this.reduceMotion.matches;
      this.interval = Math.max(1000, parseInt(this.dataset.interval, 10) || 4000);
      /* 起步先当「不在视口」处理，等 IntersectionObserver 第一次汇报再放行 ——
         没有它（或浏览器不支持）就在下面直接 resumeFor('viewport') 补上 */
      this.paused = true;
      this._pauseReasons = new Set(['viewport']);
      if (document.hidden) this._pauseReasons.add('tab');
      if (this.autoplay && this.barFill) {
        this.barFill.style.setProperty('--cf-dur', this.interval + 'ms');
      }

      this.slides.forEach((s, i) => {
        /* video_tag 不保证输出 playsinline，iOS 上少了它会强行全屏播放 */
        const v = s.querySelector('video');
        if (v) { v.playsInline = true; v.muted = true; }
        if (i < 3) this.primeMedia(i);
        this.listen(s, 'click', () => { if (i !== this.cur) this.go(i); });
      });
      this.tabs.forEach((t, i) => this.listen(t, 'click', () => this.go(i)));
      if (this.prev) this.listen(this.prev, 'click', () => this.go(this.cur - 1));
      if (this.next) this.listen(this.next, 'click', () => this.go(this.cur + 1));

      /* 键盘：焦点在 tab 上时左右方向键切换（ARIA tablist 的标准行为） */
      if (this.tabsWrap) {
        this.listen(this.tabsWrap, 'keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const n = this.cur + (e.key === 'ArrowRight' ? 1 : -1);
          this.go((n + this.slides.length) % this.slides.length);
          if (this.tabs[this.cur]) this.tabs[this.cur].focus();
        });
      }

      this.bindDrag();

      if (this.autoplay) {
        this._onVis = () => {
          document.hidden ? this.pauseFor('tab') : this.resumeFor('tab');
        };
        this.listen(document, 'visibilitychange', this._onVis);

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((es) => {
            es.forEach((e) => {
              e.isIntersecting ? this.resumeFor('viewport') : this.pauseFor('viewport');
            });
          }, { threshold: 0.35 });
          this._io.observe(this);
        } else {
          this.resumeFor('viewport');
        }
      }

      this._onResize = () => {
        clearTimeout(this._rt);
        this._rt = setTimeout(() => this.go(this.cur, true), 120);
      };
      this.listen(window, 'resize', this._onResize);

      /* 后台点选某个场景 block 时，轮播跳到那一张 */
      this._onSelect = (e) => {
        const s = e.target.closest ? e.target.closest('.cf-scenes__slide') : null;
        if (s && this.contains(s)) this.go(parseInt(s.dataset.i, 10) || 0);
      };
      this.listen(this, 'shopify:block:select', this._onSelect);

      /* 图片是懒加载的，尺寸要等它们落位才准；先按当前尺寸摆一次 */
      this.go(0, true);
      this.primeAround(0);
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => this.queueLayout());
        this._ro.observe(this.car);
        if (this.tabsWrap) this._ro.observe(this.tabsWrap);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.layout(true);
        });
      }
    }

    /* 暂停原因用 Set 记账：拖拽、切到后台、滚出视口，谁按下谁松开自己那份，
       只要还有一个原因在压着就不会恢复播放 —— 避免"松开鼠标但还在拖"之类的提前抢跑 */
    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this._cleanups.push(() => target.removeEventListener(type, handler, options));
    }

    pauseFor(reason) {
      this._pauseReasons.add(reason);
      this.applyPause();
    }

    resumeFor(reason) {
      this._pauseReasons.delete(reason);
      this.applyPause();
    }

    applyPause() {
      const should = this._pauseReasons.size > 0;
      if (should === this.paused) return;
      if (should) {
        this.pauseAutoplay();
        this.paused = true;
      } else {
        this.paused = false;
        this.resumeAutoplay();
      }
    }

    clearAutoTimer() {
      if (!this._autoTimer) return;
      clearTimeout(this._autoTimer);
      this._autoTimer = 0;
    }

    startAutoTimer(ms) {
      this.clearAutoTimer();
      if (!this.autoplay || this.paused || this.slides.length < 2) return;
      this._barRemaining = Math.max(80, ms || this.interval);
      this._barStartedAt = performance.now();
      this._autoTimer = setTimeout(() => {
        this._autoTimer = 0;
        if (this.autoplay && !this.paused) this.go((this.cur + 1) % this.slides.length, false, 'auto');
      }, this._barRemaining);
    }

    pauseAutoplay() {
      if (this._autoTimer) {
        const elapsed = Math.max(0, performance.now() - this._barStartedAt);
        this._barRemaining = Math.max(80, this._barRemaining - elapsed);
        this.clearAutoTimer();
      }
      if (this.barFill) this.barFill.classList.remove('is-play');
    }

    resumeAutoplay() {
      if (!this.autoplay) return;
      if (this.barFill) this.barFill.classList.add('is-play');
      this.startAutoTimer(this._barRemaining || this.interval);
    }

    restartBar() {
      if (!this.barFill) return;
      if (this._barRaf) cancelAnimationFrame(this._barRaf);
      this.clearAutoTimer();
      this.barFill.classList.remove('is-run', 'is-play');
      this._barRemaining = this.interval;
      if (!this.autoplay) return;
      this._barRaf = requestAnimationFrame(() => {
        this._barRaf = 0;
        if (!this.isConnected || !this.autoplay) return;
        this.barFill.classList.add('is-run');
        if (!this.paused) {
          this.barFill.classList.add('is-play');
          this.startAutoTimer(this.interval);
        }
      });
    }

    startSwitching() {
      this._switching = true;
      this.classList.add('is-switching');
      clearTimeout(this._moveTimer);
      this._moveTimer = setTimeout(() => {
        this._switching = false;
        this.classList.remove('is-switching');
        if (this._layoutAfterMove) {
          this._layoutAfterMove = false;
          this.layout(true);
        }
      }, 560);
    }

    queueLayout() {
      if (this._switching) {
        this._layoutAfterMove = true;
        return;
      }
      if (this._layoutRaf) cancelAnimationFrame(this._layoutRaf);
      this._layoutRaf = requestAnimationFrame(() => {
        this._layoutRaf = 0;
        this.layout(true);
      });
    }

    primeMedia(i) {
      if (!this.slides.length) return;
      const s = this.slides[(i + this.slides.length) % this.slides.length];
      if (!s || s.dataset.primed === '1') return;
      s.dataset.primed = '1';
      s.querySelectorAll('img').forEach((img) => {
        img.loading = 'eager';
        img.decoding = 'async';
        if (img.decode) img.decode().catch(() => {});
      });
      const v = s.querySelector('video');
      if (v) {
        v.preload = 'auto';
        if (v.readyState < 2) {
          try { v.load(); } catch (e) {}
        }
      }
    }

    primeAround(i) {
      [0, 1, 2, -1].forEach((n) => this.primeMedia(i + n));
    }

    playVideo(v) {
      if (!v) return;
      requestAnimationFrame(() => {
        if (!this.isConnected || !this.slides[this.cur] || !this.slides[this.cur].contains(v)) return;
        v.play().catch(() => {});
      });
    }

    layout(snapBar) {
      const s = this.slides[this.cur];
      if (!s) return;
      this.track.style.transform =
        'translate3d(' + (this.car.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2)) + 'px,0,0)';
      const t = this.tabs[this.cur];
      if (t && this.bar) {
        const label = t.querySelector('[data-tab-label]') || t;
        const left = t.offsetLeft + label.offsetLeft;
        if (snapBar) this.bar.classList.add('is-snap');
        this.bar.style.width = label.offsetWidth + 'px';
        this.bar.style.transform = 'translate3d(' + left + 'px,0,0)';
        if (snapBar) requestAnimationFrame(() => this.bar.classList.remove('is-snap'));
      }
    }

    scrollActiveTab() {
      if (!this.tabsWrap || this.tabsWrap.scrollWidth <= this.tabsWrap.clientWidth + 2) return;
      const t = this.tabs[this.cur];
      if (!t || !this.tabsWrap.scrollTo) return;
      const label = t.querySelector('[data-tab-label]') || t;
      const labelLeft = t.offsetLeft + label.offsetLeft;
      const left = labelLeft - (this.tabsWrap.clientWidth - label.offsetWidth) / 2;
      this.tabsWrap.scrollTo({
        left: Math.max(0, left),
        behavior: 'auto'
      });
    }

    go(i, init, source) {
      const last = this.slides.length - 1;
      const prev = this.cur;
      this.cur = Math.max(0, Math.min(last, i));
      if (!init && this.cur !== prev) this.startSwitching();
      this.primeAround(this.cur);

      let activeVideo = null;
      this.slides.forEach((s, n) => {
        const on = n === this.cur;
        s.classList.toggle('is-on', on);
        const v = s.querySelector('video');
        if (v) {
          if (on) activeVideo = v;
          else v.pause();
        }
      });
      this.tabs.forEach((t, n) => {
        const on = n === this.cur;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });

      if (init) this.track.classList.add('is-drag');
      this.layout(source === 'auto');
      if (init) requestAnimationFrame(() => this.track.classList.remove('is-drag'));
      this.playVideo(activeVideo);

      /* 说明文字淡入淡出；首次 / resize 直接切，避免空白闪一下 */
      this.descs.forEach((d, n) => {
        const on = n === this.cur;
        if (init) {
          d.classList.toggle('is-on', on);
        } else if (on) {
          d.classList.add('is-on');
        } else {
          d.classList.remove('is-on');
        }
      });

      if (this.prev) this.prev.disabled = this.cur === 0;
      if (this.next) this.next.disabled = this.cur === last;

      this.restartBar();

      /* tab 滚到可见 —— 只在用户操作且 tab 条真的溢出时做，
         否则首屏加载就会把页面拽到这个板块 */
      if (!init && source !== 'auto') this.scrollActiveTab();
    }

    bindDrag() {
      let x0 = null, dx = 0, base = 0;
      const down = (e) => {
        x0 = e.clientX; dx = 0;
        this.pauseFor('drag');
        const s = this.slides[this.cur];
        base = this.car.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2);
        this.track.classList.add('is-drag');
        if (this.track.setPointerCapture) this.track.setPointerCapture(e.pointerId);
      };
      const move = (e) => {
        if (x0 === null) return;
        dx = e.clientX - x0;
        this.track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
      };
      const release = () => {
        if (x0 === null) return;
        this.track.classList.remove('is-drag');
        const th = Math.min(90, this.car.clientWidth * 0.08);
        if (dx < -th) this.go(this.cur + 1);
        else if (dx > th) this.go(this.cur - 1);
        else this.go(this.cur);
        x0 = null;
        this.resumeFor('drag');
      };
      this.listen(this.track, 'pointerdown', down);
      this.listen(this.track, 'pointermove', move);
      this.listen(this.track, 'pointerup', release);
      this.listen(this.track, 'pointercancel', release);
      /* 拖完了别顺手把 slide 的点击也触发一遍 */
      this.listen(this.track, 'click', (e) => {
        if (Math.abs(dx) > 6) { e.stopPropagation(); e.preventDefault(); }
      }, true);
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      if (this._cleanups) {
        this._cleanups.forEach((off) => off());
        this._cleanups = [];
      }
      if (this._ro) this._ro.disconnect();
      if (this._io) this._io.disconnect();
      if (this._barRaf) cancelAnimationFrame(this._barRaf);
      if (this._layoutRaf) cancelAnimationFrame(this._layoutRaf);
      this.clearAutoTimer();
      clearTimeout(this._rt);
      clearTimeout(this._moveTimer);
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-screen"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 4 · 环境光滑块驱动镜面亮度
   所有视觉（镜面亮度、白光、轨道填充、读数）都只读 --cf-lv，
   所以这里唯一的职责就是往 --cf-lv 写一个 0~1 的数
   ============================================================ */
if (!customElements.get('cf-screen')) {
  customElements.define('cf-screen', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.rng = this.querySelector('[data-range]');
      this.dial = this.querySelector('.cf-screen__dial');
      this.nits = this.querySelector('[data-nits]');
      this.env = this.querySelector('[data-env]');
      this.hand = this.querySelector('[data-hand]');
      if (!this.rng || !this.dial) return;
      this._ready = true;

      this.min = parseFloat(this.dataset.nitsMin) || 0;
      this.max = parseFloat(this.dataset.nitsMax) || 1500;
      this.period = parseFloat(this.dataset.period) || 3400;
      this.swing = this.dataset.swing === '1';
      /* 自动摆动围绕这个「初始停留亮度」摆，而不是死磕 0.5 —— 停靠点因此可配置 */
      this.start = (parseFloat(this.rng.value) || 0) / 100;

      /* 挡位表直接从滑块下面那排刻度里读，不另写一份 */
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-levels] span'))
        .map((el) => [parseFloat(el.dataset.upto) / 100, el.textContent.trim()]);

      this.touched = false;
      this.visible = false;
      this.raf = 0;
      this.t0 = null;

      const stop = () => {
        this.dial.classList.remove('is-hint');
        if (this.touched) return;
        this.touched = true;
        this.halt();
      };
      ['pointerdown', 'touchstart', 'keydown', 'input'].forEach((ev) => {
        this.rng.addEventListener(ev, stop, { passive: true });
      });
      this.rng.addEventListener('input', () => this.paint(this.rng.value / 100));

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !this.swing) {
        /* 系统开了减弱动效 / 后台关了自动摆动：
           停在一个能看出高亮的位置，别让首帧是全暗的 */
        this.touched = true;
        this.paint(this.rng.value / 100);
      } else {
        this.paint(this.rng.value / 100);
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((es) => {
            es.forEach((e) => {
              this.visible = e.isIntersecting;
              this.visible ? this.wiggle() : this.halt();
            });
          }, { threshold: 0.4 });
          this.io.observe(this.dial);
        } else {
          this.visible = true;
          this.wiggle();
        }
      }
    }

    paint(lv) {
      lv = lv < 0 ? 0 : lv > 1 ? 1 : lv;
      this.style.setProperty('--cf-lv', lv.toFixed(3));
      if (this.nits) {
        this.nits.textContent = Math.round((this.min + (this.max - this.min) * lv) / 10) * 10;
      }
      if (this.env && this.steps.length) {
        for (let i = 0; i < this.steps.length; i++) {
          if (lv < this.steps[i][0]) { this.env.textContent = this.steps[i][1]; break; }
        }
      }
      if (this.hand) {
        /* 手沿着弧线上的贝塞尔坐标走，跟滑柄读同一个 lv ——
           两者永远同方向、同步长，不会出现各自动画对不上的情况。
           坐标对应弧线 svg 的 viewBox="0 0 200 32" 里那条 M74 24 Q100 4 126 24 */
        const t = lv;
        const x = (1 - t) * (1 - t) * 74 + 2 * (1 - t) * t * 100 + t * t * 126;
        const y = (1 - t) * (1 - t) * 24 + 2 * (1 - t) * t * 4 + t * t * 24;
        this.hand.style.left = (x / 200 * 100) + '%';
        this.hand.style.top = (y - 8.5) + 'px';
      }
    }

    /* 自动来回摆：正弦从最暗扫到最亮，把手引过来。sin 起点取 -π/2，所以从暗开始 */
    step(ts) {
      if (this.touched || !this.visible) { this.raf = 0; this.t0 = null; return; }
      if (this.t0 === null) this.t0 = ts;
      const phase = Math.sin((ts - this.t0) / this.period * Math.PI * 2 - Math.PI / 2);
      /* 摆动幅度按起点到两端的余量分别夹一下，这样摆到边上也不会贴死在 0 或 1 不动 */
      const amp = phase >= 0 ? Math.min(0.42, 1 - this.start) : Math.min(0.42, this.start);
      const lv = this.start + amp * phase;
      /* 不四舍五入到整数百分比——之前摆到波峰波谷附近会有好几帧读数相同，
         滑柄和手看起来像卡了一下，改成写连续小数才是真的顺滑 */
      this.rng.value = lv * 100;
      this.paint(lv);
      this.raf = requestAnimationFrame((t) => this.step(t));
    }

    wiggle() {
      if (!this.touched && this.visible && !this.raf) {
        this.raf = requestAnimationFrame((t) => this.step(t));
      }
    }

    halt() {
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
      this.t0 = null;
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      this.halt();
      if (this.io) this.io.disconnect();
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-usp-aligned"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 7 · 卖点格子 → 详情弹窗
   每份详情已经是弹窗里一个真实节点，这里只负责显示哪一个
   ============================================================ */
if (!customElements.get('cf-usp-aligned')) {
  customElements.define('cf-usp-aligned', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.modal = this.querySelector('[data-modal]');
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      if (!this.modal || !this.panels.length) return;
      this._ready = true;

      this.sheet = this.modal.querySelector('.cf-usp-aligned__sheet');
      this.body = this.modal.querySelector('[data-body]');
      this.count = this.modal.querySelector('[data-count]');
      this.closeBtn = this.modal.querySelector('[data-close]');
      this.cur = -1;
      this.back = null;
      this.hotTimer = 0;
      this.openTimer = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.querySelectorAll('[data-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = parseInt(btn.dataset.open, 10);
          this.popCell(btn.closest('.cf-usp-aligned__cell'));
          window.clearTimeout(this.openTimer);
          this.openTimer = window.setTimeout(() => this.open(i), this.reduce.matches ? 0 : 120);
        });
      });
      this.wireCells();
      /* 翻页/关闭按钮都不让 click 往上冒泡 —— 之前只在遮罩层判断「点击点在不在
         sheet 里」，理论上够了，但只要祖先链上（不管是这个自定义元素自己，还是
         主题里其它监听 document/body 点击来关弹层的全局脚本）还挂着别的逻辑，
         这个 click 事件冒泡上去就可能被误判成「点了弹窗外面」。直接在源头掐断
         冒泡，不管上面挂什么逻辑都不会再被牵连 */
      if (this.closeBtn) this.closeBtn.addEventListener('click', (e) => { e.stopPropagation(); this.close(); });
      const prev = this.modal.querySelector('[data-prev]');
      const next = this.modal.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); this.move(-1); });
      if (next) next.addEventListener('click', (e) => { e.stopPropagation(); this.move(1); });
      /* 点遮罩关闭：原来用 e.target === this.modal 精确匹配，
         但左右切换箭头是 fill="none" 只描边的 svg，命中判定在个别浏览器上
         会落在 path/svg 而不是 button，冒泡到这里理论上还是不该等于 modal ——
         但用「点击点有没有落在 sheet 范围内」判断更稳：只要点在弹窗面板
         （包括导航条、翻页按钮）以内就绝不关闭，不用依赖 target 具体是哪个节点 */
      this.modal.addEventListener('click', (e) => { if (!this.sheet.contains(e.target)) this.close(); });

      this.onKey = (e) => {
        if (!this.modal.classList.contains('is-on')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft') this.move(-1);
        else if (e.key === 'ArrowRight') this.move(1);
        else if (e.key === 'Tab') this.trap(e);
      };
      document.addEventListener('keydown', this.onKey);

      /* 编辑器里点侧边栏的卖点区块，直接把对应详情弹出来。
         事件从区块自己身上冒泡上来，挂在 this 上就够，不在编辑器里它根本不触发 */
      this.onSelect = (e) => {
        const hit = this.querySelector('[data-bid="' + e.detail.blockId + '"]');
        if (hit) this.open(parseInt(hit.dataset.open, 10));
      };
      this.onDeselect = () => this.close();
      this.addEventListener('shopify:block:select', this.onSelect);
      this.addEventListener('shopify:block:deselect', this.onDeselect);
    }

    /* 每个格子的点击反馈：不再跟随鼠标倾斜，只在按下和 click 时短暂浮起。 */
    wireCells() {
      this.querySelectorAll('.cf-usp-aligned__cell').forEach((cell) => {
        const hit = cell.querySelector('.cf-usp-aligned__hit');
        if (!hit) return;

        const press = () => {
          if (this.reduce.matches) return;
          cell.classList.add('is-pressed');
        };
        const release = () => {
          cell.classList.remove('is-pressed');
        };
        hit.addEventListener('pointerdown', press);
        hit.addEventListener('pointerup', release);
        hit.addEventListener('pointercancel', release);
        hit.addEventListener('pointerleave', release);
      });
    }

    popCell(cell) {
      if (!cell || this.reduce.matches) return;
      window.clearTimeout(this.hotTimer);
      this.querySelectorAll('.cf-usp-aligned__cell.is-hot').forEach((el) => el.classList.remove('is-hot'));
      cell.classList.add('is-hot');
      this.hotTimer = window.setTimeout(() => cell.classList.remove('is-hot'), 520);
    }

    pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    show(i) {
      this.cur = i;
      this.panels.forEach((p, k) => { p.hidden = k !== i; });
      if (this.body) this.body.scrollTop = 0;
      if (this.count) this.count.textContent = this.pad(i + 1) + ' / ' + this.pad(this.panels.length);
    }

    open(i) {
      if (isNaN(i) || !this.panels[i]) return;
      this.back = document.activeElement;
      this.show(i);
      this.modal.classList.add('is-on');
      /* 锁滚动时补上滚动条的宽度，不然背景会横跳一下 */
      const sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add('cf-usp-aligned-lock');
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      if (this.closeBtn) this.closeBtn.focus();
    }

    close() {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.hotTimer);
      this.querySelectorAll('.cf-usp-aligned__cell.is-hot,.cf-usp-aligned__cell.is-pressed').forEach((el) => el.classList.remove('is-hot', 'is-pressed'));
      if (!this.modal.classList.contains('is-on')) return;
      this.modal.classList.remove('is-on');
      document.body.classList.remove('cf-usp-aligned-lock');
      document.body.style.paddingRight = '';
      /* 关掉里面可能在播的详情视频 */
      this.modal.querySelectorAll('video').forEach((v) => v.pause());
      if (this.back && this.back.focus) this.back.focus();
    }

    move(d) {
      const n = this.panels.length;
      this.show((this.cur + d + n) % n);
    }

    /* aria-modal 只是个声明，真要把焦点关在弹窗里还得自己接 Tab */
    trap(e) {
      const f = this.sheet.querySelectorAll('button, a[href], video[controls], [tabindex]:not([tabindex="-1"])');
      const on = Array.prototype.slice.call(f).filter((el) => el.offsetParent !== null);
      if (!on.length) return;
      const first = on[0];
      const last = on[on.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.hotTimer);
      document.body.classList.remove('cf-usp-aligned-lock');
      document.body.style.paddingRight = '';
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-usp"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   板块 7 · 卖点格子 → 详情弹窗
   每份详情已经是弹窗里一个真实节点，这里只负责显示哪一个
   ============================================================ */
if (!customElements.get('cf-usp')) {
  customElements.define('cf-usp', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        this._boot = () => this.init();
        document.addEventListener('DOMContentLoaded', this._boot, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this.modal = this.querySelector('[data-modal]');
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      if (!this.modal || !this.panels.length) return;
      this._ready = true;

      this.sheet = this.modal.querySelector('.cf-usp__sheet');
      this.body = this.modal.querySelector('[data-body]');
      this.count = this.modal.querySelector('[data-count]');
      this.closeBtn = this.modal.querySelector('[data-close]');
      this.cur = -1;
      this.back = null;
      this.hotTimer = 0;
      this.openTimer = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.querySelectorAll('[data-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = parseInt(btn.dataset.open, 10);
          this.popCell(btn.closest('.cf-usp__cell'));
          window.clearTimeout(this.openTimer);
          this.openTimer = window.setTimeout(() => this.open(i), this.reduce.matches ? 0 : 120);
        });
      });
      this.wireCells();
      /* 翻页/关闭按钮都不让 click 往上冒泡 —— 之前只在遮罩层判断「点击点在不在
         sheet 里」，理论上够了，但只要祖先链上（不管是这个自定义元素自己，还是
         主题里其它监听 document/body 点击来关弹层的全局脚本）还挂着别的逻辑，
         这个 click 事件冒泡上去就可能被误判成「点了弹窗外面」。直接在源头掐断
         冒泡，不管上面挂什么逻辑都不会再被牵连 */
      if (this.closeBtn) this.closeBtn.addEventListener('click', (e) => { e.stopPropagation(); this.close(); });
      const prev = this.modal.querySelector('[data-prev]');
      const next = this.modal.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); this.move(-1); });
      if (next) next.addEventListener('click', (e) => { e.stopPropagation(); this.move(1); });
      /* 点遮罩关闭：原来用 e.target === this.modal 精确匹配，
         但左右切换箭头是 fill="none" 只描边的 svg，命中判定在个别浏览器上
         会落在 path/svg 而不是 button，冒泡到这里理论上还是不该等于 modal ——
         但用「点击点有没有落在 sheet 范围内」判断更稳：只要点在弹窗面板
         （包括导航条、翻页按钮）以内就绝不关闭，不用依赖 target 具体是哪个节点 */
      this.modal.addEventListener('click', (e) => { if (!this.sheet.contains(e.target)) this.close(); });

      this.onKey = (e) => {
        if (!this.modal.classList.contains('is-on')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft') this.move(-1);
        else if (e.key === 'ArrowRight') this.move(1);
        else if (e.key === 'Tab') this.trap(e);
      };
      document.addEventListener('keydown', this.onKey);

      /* 编辑器里点侧边栏的卖点区块，直接把对应详情弹出来。
         事件从区块自己身上冒泡上来，挂在 this 上就够，不在编辑器里它根本不触发 */
      this.onSelect = (e) => {
        const hit = this.querySelector('[data-bid="' + e.detail.blockId + '"]');
        if (hit) this.open(parseInt(hit.dataset.open, 10));
      };
      this.onDeselect = () => this.close();
      this.addEventListener('shopify:block:select', this.onSelect);
      this.addEventListener('shopify:block:deselect', this.onDeselect);
    }

    /* 每个格子的点击反馈：不再跟随鼠标倾斜，只在按下和 click 时短暂浮起。 */
    wireCells() {
      this.querySelectorAll('.cf-usp__cell').forEach((cell) => {
        const hit = cell.querySelector('.cf-usp__hit');
        if (!hit) return;

        const press = () => {
          if (this.reduce.matches) return;
          cell.classList.add('is-pressed');
        };
        const release = () => {
          cell.classList.remove('is-pressed');
        };
        hit.addEventListener('pointerdown', press);
        hit.addEventListener('pointerup', release);
        hit.addEventListener('pointercancel', release);
        hit.addEventListener('pointerleave', release);
      });
    }

    popCell(cell) {
      if (!cell || this.reduce.matches) return;
      window.clearTimeout(this.hotTimer);
      this.querySelectorAll('.cf-usp__cell.is-hot').forEach((el) => el.classList.remove('is-hot'));
      cell.classList.add('is-hot');
      this.hotTimer = window.setTimeout(() => cell.classList.remove('is-hot'), 520);
    }

    pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    show(i) {
      this.cur = i;
      this.panels.forEach((p, k) => { p.hidden = k !== i; });
      if (this.body) this.body.scrollTop = 0;
      if (this.count) this.count.textContent = this.pad(i + 1) + ' / ' + this.pad(this.panels.length);
    }

    open(i) {
      if (isNaN(i) || !this.panels[i]) return;
      this.back = document.activeElement;
      this.show(i);
      this.modal.classList.add('is-on');
      /* 锁滚动时补上滚动条的宽度，不然背景会横跳一下 */
      const sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add('cf-usp-lock');
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      if (this.closeBtn) this.closeBtn.focus();
    }

    close() {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.hotTimer);
      this.querySelectorAll('.cf-usp__cell.is-hot,.cf-usp__cell.is-pressed').forEach((el) => el.classList.remove('is-hot', 'is-pressed'));
      if (!this.modal.classList.contains('is-on')) return;
      this.modal.classList.remove('is-on');
      document.body.classList.remove('cf-usp-lock');
      document.body.style.paddingRight = '';
      /* 关掉里面可能在播的详情视频 */
      this.modal.querySelectorAll('video').forEach((v) => v.pause());
      if (this.back && this.back.focus) this.back.focus();
    }

    move(d) {
      const n = this.panels.length;
      this.show((this.cur + d + n) % n);
    }

    /* aria-modal 只是个声明，真要把焦点关在弹窗里还得自己接 Tab */
    trap(e) {
      const f = this.sheet.querySelectorAll('button, a[href], video[controls], [tabindex]:not([tabindex="-1"])');
      const on = Array.prototype.slice.call(f).filter((el) => el.offsetParent !== null);
      if (!on.length) return;
      const first = on[0];
      const last = on[on.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    disconnectedCallback() {
      if (this._boot) document.removeEventListener('DOMContentLoaded', this._boot);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.hotTimer);
      document.body.classList.remove('cf-usp-lock');
      document.body.style.paddingRight = '';
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-wide-media-link"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-wide-media-link')) {
  customElements.define('cf-wide-media-link', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      video.play().catch(() => {});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
